import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomHttpClient } from './custom-http-client.service';
import { HttpClient } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { PatientAiContext } from './patient-ai-context.service';

/**
 * AI API Request interface
 */
export interface AiApiRequest {
  message: string;
  user_id?: number;
  practice_id?: number;
  screen?: string;
  active_tab?: string;
  patient_id?: string;
  r_patient_id?: number | null;
  program_id?: number | null;
  timestamp?: string;
  session_id?: string;
  chat_id?: string;
  task?: string;
  environment?: string;
  patient_data?: PatientAiContext;
  context?: {
    screen_name?: string;
    active_tab?: string;
    patient_id?: number | null;
    program_id?: number | null;
    route_url?: string;
    user_info?: any;
  };
}

/**
 * AI API Response interface
 */
export interface AiApiResponse {
  message: string;
  timestamp: string;
  context_understood?: boolean;
}

/**
 * Real AI API Service
 * Connects to the actual backend AI service
 * Replace the API_ENDPOINT with your actual endpoint once available
 */
@Injectable({
  providedIn: 'root'
})
export class RealAiApiService {

  // Driven by environment — no hardcoding needed
  private readonly API_ENDPOINT_get = 'https://test-bot-11.uc.r.appspot.com/health';
  private readonly API_ENDPOINT_post = environment.aiEndpoint;

  constructor(private httpClient: CustomHttpClient,
              public http: HttpClient) { }

  public sendMessage(request: AiApiRequest): Observable<AiApiResponse> {

    let a = {
      patient_id: "P0001",
      session_id: "S1",
      chat_id: "C1",
      message: "Hi, I have diabetes. What should I focus on daily?"
    }
    // Make POST request to real AI backend
    return this.http.post(this.API_ENDPOINT_post, request).map(
      (response: any) => {
        return response;
        // Transform backend response to match AiApiResponse interface
        /*return {
          message: response.message || response.response || response.data?.message,
          timestamp: response.timestamp || new Date().toISOString(),
          context_understood: response.context_understood !== false
        } as AiApiResponse;*/
      }
    );
  }


  getCurrentUserChats(): Promise<any> {
    return this.http.get(this.API_ENDPOINT_get).toPromise()
      .then(res => res);
  }
}
